import makeDrawerState from './_makeDrawerState.js';

export const { actions, reducer } = makeDrawerState('lruDrawer');

export default reducer;
